function getVehicleGroupKey(detection: { id: number; plate?: string | null }): string {
  return detection.plate ? detection.plate.toLowerCase() : `unknown-${detection.id}`;
}

export default getVehicleGroupKey;
